'use strict';

angular.module('fan.proyectos')
  .config(function ($stateProvider) {
    $stateProvider.state('proyectos', {
      url: '/proyectos',
      data: {title: 'Proyectos'},
      template: '<fan-proyectos/>',
    });
  });





// WEBPACK FOOTER //
// ./src/fan/proyectos/routes/proyectos.js